import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from '@material-ui/core';
import * as React from 'react';

interface DoNotEmailAgainProps {
    show: boolean;
    requestClose: () => void;
    onDisqualify?: (note: string) => void;
}

interface DoNotEmailAgainState {
    optOutNote: string;
}

export class DoNotEmailAgain extends React.Component<DoNotEmailAgainProps, DoNotEmailAgainState> {
    constructor(props: DoNotEmailAgainProps) {
        super(props);
        this.state = { optOutNote: '' };
    }

    editNoteValue = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ optOutNote: event.target.value });
    };

    handleDoNotEmail = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        this.props.onDisqualify(this.state.optOutNote);
    };

    render() {
        return (
            <Dialog className="opt-out-dialog" open={this.props.show} onClose={this.props.requestClose}>
                <DialogTitle>
                    <Typography variant="h4" component="div">
                        Do Not Email
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <div>Are you sure?</div>
                    <TextField
                        placeholder="Add Note"
                        onChange={this.editNoteValue}
                        multiline={true}
                        fullWidth={true}
                        className="opt-out-text-field"
                        helperText="This will disqualify the candidate and remove from ALL active email sequences."
                    />
                </DialogContent>
                <DialogActions>
                    <Button key="do-not-email-again-cancel" variant="text" onClick={this.props.requestClose}>
                        Cancel
                    </Button>
                    <Button key="do-not-email-again-disqualify" variant="text" onClick={this.handleDoNotEmail}>
                        Disqualify
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}
